import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpedienteFiltroDto } from '../../../dto/expediente/expediente.filtro.dto';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { TableColumn } from '../../../dto/util/table-column';
import { ExpedienteDimarDto } from '../../../dto/expediente/expediente-dimar.dto';
import { PartesProcesoDimarDto } from '../../../dto/expediente/partes-proceso.dimar.dto';
import { ActuacionesDimarDto } from '../../../dto/expediente/actuaciones-dimar.dto';
import moment from 'moment';
import { ExpedienteService } from '../../../services/expediente.service';
import { UtilService } from '../../../services/util.service';
import { Constants } from '../../../constants/constants';
import { SolicitudDocumentosComponent } from '../solicitud-documentos/solicitud-documentos.component';
import { ModalService } from '../../../services/util/modal.service';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { TranslateService } from '@ngx-translate/core';
import { ListasService } from '../../../services/listas.service';
import { TipoDocumentoDto } from '../../../dto/expediente/tipo-documento-dto.dto';
import { combineLatest } from 'rxjs';
import {EntidadApiResponse} from "../../../dto/entidad/entidad-response.dto";
import {EntidadService} from "../../../services/entidad.service";
import { UserDataDto } from '../../../dto/auth/user-data.dto';

@Component({
  selector: 'app-detalle-dimar',
  templateUrl: './detalle-dimar.component.html',
  styleUrl: './detalle-dimar.component.scss',
})
export class DetalleDimarComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  entidadId = 6;
  entidad!: EntidadApiResponse;
  expedienteId = 0;
  usuarioCreadorId = 0;
  expedienteData: ExpedienteDimarDto = {};
  partesProceso: PartesProcesoDimarDto[] = [];
  actuaciones: ActuacionesDimarDto[] = [];
  columnsActuaciones: TableColumn[] = [];
  columnsPartesProceso: TableColumn[] = [];
  tiposDocumento: TipoDocumentoDto[] = [];
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  showButton = true;
  isCreator = false;
  public role = '';

  filtrosActuaciones: FiltroDto<ExpedienteFiltroDto> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'marca_tiempo',
    filtros: {},
  };

  filtrosPartesProceso: FiltroDto<ExpedienteFiltroDto> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'marca_tiempo',
    filtros: {},
  };

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  tableText: any = {};

  guiaText: any = {};
  guiaDIMARText: any = {};
  showGuia: boolean = true;

  tipoDocumentoUsuario = '';
  numeroIdentificacion = '';

  constructor(
    private readonly service: ExpedienteService,
    private readonly listaService: ListasService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly modalService: ModalService,
    private readonly translate: TranslateService,
    private entidadService: EntidadService
  ) {
    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
    }
    combineLatest({
      guias: this.translate.stream('guias-interactivas'),
      guiaDimar: this.translate.stream('guia-DIMAR'),
      tabla: this.translate.stream('detalle-DIMAR'),
    }).subscribe(({ guias, guiaDimar, tabla }) => {
      // Asignar traducciones a variables
      this.guiaText = guias;
      this.guiaDIMARText = guiaDimar;
      this.tableText = tabla;
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.initColumns();
    this.cargarEntidad();
    this.expedienteId = this.activatedRoute.snapshot.params['expedienteId'];
    this.usuarioCreadorId = this.activatedRoute.snapshot.params['usuarioId'];
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.tipoDocumentoUsuario = infoInicioSesion.tipoDocumento;
    this.numeroIdentificacion = infoInicioSesion.identificacion;
    this.isCreator = infoInicioSesion.idUsuario === +this.usuarioCreadorId;
    this.getExpendienteDetail(this.expedienteId,this.tipoDocumentoUsuario,this.numeroIdentificacion);
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
    // Se toma la información del usuario que inicia sesión
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaText['expediente-titulo'],
      descripcionPantalla: this.guiaDIMARText['descripcion-pantalla'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaDIMARText['tour-titulo'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#encabezado',
          popover: {
            title: this.guiaDIMARText['encabezado-titulo'],
            description: this.guiaDIMARText['encabezado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: this.guiaDIMARText['crear-solicitud-titulo'],
            description: this.guiaDIMARText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historicoBtn',
          popover: {
            title: this.guiaDIMARText['historico-titulo'],
            description: this.guiaDIMARText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#documentos',
          popover: {
            title: this.guiaDIMARText['documentos-titulo'],
            description: this.guiaDIMARText['documentos-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaDIMARText['filtro-titulo'],
            description: this.guiaDIMARText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaDIMARText['historico-titulo'],
            description: this.guiaDIMARText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#fecha_actuacion',
          popover: {
            title: this.guiaDIMARText['fecha-actuacion-titulo'],
            description: this.guiaDIMARText['fecha-actuacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#usuario',
          popover: {
            title: this.guiaDIMARText['usuario-titulo'],
            description: this.guiaDIMARText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#estado_proceso',
          popover: {
            title: this.guiaDIMARText['estado-titulo'],
            description: this.guiaDIMARText['estado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#anotacion',
          popover: {
            title: this.guiaDIMARText['anotacion-titulo'],
            description: this.guiaDIMARText['anotacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#fecha_registro',
          popover: {
            title: this.guiaDIMARText['fecha-registro-titulo'],
            description: this.guiaDIMARText['fecha-registro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };

    const isShowGuia = sessionStorage.getItem(Constants.SHOW_GUIA_DETALLE_DIMAR) != null ? false : this.showGuia
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (infoInicioSesion.primerInicioSesion && isShowGuia) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
      sessionStorage.setItem(Constants.SHOW_GUIA_DETALLE_DIMAR, 'false')
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
  }

  getExpendienteDetail(expedienteId: number,tipoDocumentoUsuario:string,numeroIdentificacion:string) {
    this.listaService.getTipoDocumento().subscribe({
      next: data => {
        this.tiposDocumento = data;
        this.service.getExpedienteDimar(expedienteId,tipoDocumentoUsuario,numeroIdentificacion).subscribe({
          next: data => {
            //this.expedienteData = this.formatDates(data);
            this.expedienteData = data;
            this.actuaciones = this.expedienteData.actuaciones!;
            this.partesProceso = this.expedienteData.partes_proceso!;
            this.partesProceso.forEach(parteProceso => {
              const descripcionDoc = ' - ' + (this.tiposDocumento.find(
                tipo => tipo.Tipo_Documento == parteProceso['tipoIdentificacion'])?.Descripcion
                ?? '');
              parteProceso['tipoIdentificacionCompleto'] =
                parteProceso['tipoIdentificacion'] + descripcionDoc;
            });
            this.initColumns();
          },
          error: err => {
            console.error('Error getting data', err);
          },
        });
      },
      error: err => {
        console.error('Error getting data document', err);
      },
    });

  }

  formatDates(data: ExpedienteDimarDto): ExpedienteDimarDto {
    data.actuaciones?.map(item => {
      item.fecha_actuacion = moment(item.fecha_actuacion).format('YYYY-MM-DD ');
      item.fecha_registro = moment(item.fecha_registro).format('YYYY-MM-DD');
    });
    return data;
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }

  initColumns() {
    this.columnsPartesProceso = [
      {
        field: 'tipoIdentificacionCompleto',
        title: this.tableText['tipo-documento'],
        type: 'select',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'tipoIdentificacionCompleto',
      },
      {
        field: 'numeroIdentificacion',
        title: this.tableText['numero-dpcumento'],
        type: 'number',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'numeroIdentificacion',
      },
      {
        field: 'nombre',
        title: this.tableText['nombre'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'nombre',
      },
      {
        field: 'apellidos',
        title: this.tableText['apellidos'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'apellidos',
      },
      {
        field: 'calidad',
        title: this.tableText['calidad'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'calidad',
      },
    ];

    this.columnsActuaciones = [
      {
        field: 'fecha_actuacion',
        title: this.tableText['fecha-actuacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fecha_actuacion',
        pipe: 'dd/MM/yyyy HH:mm',
      },
      {
        field: 'usuario',
        title: this.tableText['usuario'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'usuario',
      },
      {
        field: 'estado_proceso',
        title: this.tableText['estado'],
        type: 'select',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'estado',
      },
      {
        field: 'anotacion',
        title: this.tableText['anotacion'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'anotacion',
      },
      {
        field: 'fecha_registro',
        title: this.tableText['fecha-registro'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fecha_registro',
        pipe: 'dd/MM/yyyy HH:mm',
      },
    ];
  }

  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}/solicitudes`,
    ]);
  }

  openModal(): void {
    const modalData: any = {
      entidadId: this.entidadId,
      expedienteId: this.expedienteId,
      numeroProceso: this.expedienteData?.numero_proceso,
    };
    this.modalService.openModal(SolicitudDocumentosComponent, modalData);
  }
}
